"use strict";
import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import { RadioGroup, RadioButton } from 'react-radio-buttons';




class LectureEvaluation extends Component {
    constructor(props)
    {
        super(props);

        this.fetchLectureUnits = this.fetchLectureUnits.bind(this);
        this.submitEvaluation = this.submitEvaluation.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.onFormSelection = this.onFormSelection(this);
    
        this.updateSelectedLUnit= this.updateSelectedLUnit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.punctuality = this.punctuality.bind(this);
        this.courseObjectives = this.courseObjectives.bind(this);
        this.preparedness = this.preparedness.bind(this);
        this.appropriateExamples = this.appropriateExamples.bind(this);
        this.interactivity = this.interactivity.bind(this);
        this.stimulatedInterest = this.stimulatedInterest.bind(this);
        this.diverseInstruction = this.diverseInstruction.bind(this);
        this.accessibleToStudents = this.accessibleToStudents.bind(this);
        this.helpfulToStudents = this.helpfulToStudents.bind(this);
        this.individualAttention = this.individualAttention.bind(this);
        this.infoOnAssessment = this.infoOnAssessment.bind(this);
        this.timelyFeedback = this.timelyFeedback.bind(this);
        this.sufficientAssignment = this.sufficientAssignment.bind(this);
        this.overallExperience = this.overallExperience.bind(this);
        this.recommendation = this.recommendation.bind(this);

        this.invalidateSelection = this.invalidateSelection.bind(this);


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            allLUnits:[
                {"Code":"BCT 2205", "Title":"Introduction to MacroEconomics", "Lecturer":"Dr. David Kamau"},
                {"Code":"BIT 2100", "Title":"Business Law", "Lecturer":"Mr. Lawrence Anok"},
                {"Code":"BST 2005", "Title":"Business Modelling", "Lecturer":"Mrs. Jane Akinyi"},
                {"Code":"HRM 3005", "Title":"Entrepreneurship II", "Lecturer":"Dr. John Mutinda"},
                {"Code":"SMA 1108", "Title":"Probability &  Statistics", "Lecturer":"Mr. Joseph wafula"},
                {"Code":"HRM 3107", "Title":"Development Studies", "Lecturer":"Mrs. Betty Kanyi"}

            ],
            selectedLUnit:null,
            api_loading:false,
            api_loading_message:"",
            loading:false,
            evaluationFeedback:"",
            evaluationOccured:true,
            units_message: "",
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            selectedResponse:"",
            server_changes_made:false,

            course_objectives:"",
            punctual:"",
            prepared:"",
            appropriate_examples:"",
            interaction:"",
            stimulated_interest:"",
            diverse_instruction:"",
            accessible_to_students:"",
            helpful_to_students:"",
            individual_attention:"",
            info_on_assessment:"",
            timely_feedback:"",
            sufficient_assignment:"",
            overall_experience:"",
            recommend:""

        }
    }

    recommendation(event) {
        this.setState({
          recommend: event.target.value
        });
      }

    overallExperience(event) {
        this.setState({
          overall_experience: event.target.value
        });
      }

    sufficientAssignment(event) {
        this.setState({
          sufficient_assignment: event.target.value
        });
      }

   timelyFeedback(event) {
        this.setState({
          timely_feedback: event.target.value
        });
      }

    infoOnAssessment(event) {
        this.setState({
          info_on_assessment: event.target.value
        });
      }

    individualAttention(event) {
        this.setState({
          individual_attention: event.target.value
        });
      }

    helpfulToStudents(event) {
        this.setState({
          helpful_to_students: event.target.value
        });
      }

    accessibleToStudents(event) {
        this.setState({
          accessible_to_students: event.target.value
        });
      }

    diverseInstruction(event) {
        this.setState({
          diverse_instruction: event.target.value
        });
      }

    stimulatedInterest(event) {
        this.setState({
          stimulated_interest: event.target.value
        });
      }

    interactivity(event) {
        this.setState({
          interaction: event.target.value
        });
      }

    appropriateExamples(event) {
        this.setState({
          appropriate_examples: event.target.value
        });
      }

    preparedness(event) {
        this.setState({
          prepared: event.target.value
        });
      }

    courseObjectives(event) {
        this.setState({
          course_objectives: event.target.value
        });
      }

    punctuality(event) {
        this.setState({
          punctual: event.target.value
        });
      }

    handleChange(event) {
        console.log("selected response",  event.target.value);

        this.setState({
          selectedResponse: event.target.value
        });
      }


    updateSelectedLUnit(event)
      {
        let code = event.target.value;

        let selLUnit = null;

        console.log("Selected code", code)


        for(let l= 0; l < this.state.allLUnits.length; l++)
          {
            if(this.state.allLUnits[l].Code === code)
            {
                selLUnit = this.state.allLUnits[l]; 
                break;
            }
          }

          this.setState({selectedLUnit: selLUnit, evaluationOccured:false});
      }

      onFormSelection()
      {

      
          
        console.log("selected ", );

      }

      invalidateSelection(){

        for(let l= 0; l < this.state.allLUnits.length; l++)
        {
          if(this.state.allLUnits[l].Code === this.state.selectedLUnit.Code)
          {
              this.state.allLUnits.splice(l, 1);
              break;
          }
        }

          this.setState({
            selectedLUnit:null,
            course_objectives:"",
            punctual:"",
            prepared:"",
            appropriate_examples:"",
            interaction:"",
            stimulated_interest:"",
            diverse_instruction:"",
            accessible_to_students:"",
            helpful_to_students:"",
            individual_attention:"",
            info_on_assessment:"",
            timely_feedback:"",
            sufficient_assignment:"",
            overall_experience:"",
            recommend:""
          })
      }

     

      submitEvaluation()
      {

                this.setState({loading:true});
                let _this = this;

                const url = this.props.base_url +"/student/lecture-evaluation";

                superagent
                .post(url)
                .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                        year:_this.props.student_details.class_details.Year,
                        semester:_this.props.student_details.class_details.Semester,
                       })
                .set('Accept', 'application/json')
                .set('Content-Type', 'application/json')
                .then(function(res){
                    //res.body, res.headers, res.status
                    let error = res.body.error;
                    console.log("Response", res.body);


                    if(!error)
                    {
                        console.log("Process", "successful loading");

                        _this.setState({evaluationFeedback:res.body.message, evaluationOccured:true,loaded_successfully:true,loading:false, api_error_message:res.body.message,server_changes_made:true});

                    }
                    else
                    {
                        _this.setState({evaluationFeedback:res.body.message, evaluationOccured:true,loaded_successfully:true,loading:false, api_error_message:res.body.message,server_changes_made:true});
                  
                    }

                })
                .catch(function(err){

                    console.log("error response", err);
                    _this.setState({evaluationFeedback:err, evaluationOccured:true,loaded_successfully:false,loading:false, api_error_message:err,server_changes_made:true});
           
                });

      }


  fetchLectureUnits()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/student/getlectureunits";

            superagent
            .post(url)
            .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                    year:_this.props.student_details.class_details.Year,
                    semester:_this.props.student_details.class_details.Semester})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                if(!error)
                {
                    console.log("Process", "successful loading");

                    _this.setState({allUnits:res.body.subjects,loaded_successfully:true,loading:false, api_error_message:"",server_changes_made:true});

                }
                else
                {
                    _this.setState({loading:false, allUnits:[],  units_message: res.body.message,loaded_successfully:false, api_error_message:res.body.message, server_changes_made:true});
                }

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, allUnits:[],  loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderEvaluationFeedback()
  {
    const _this = this;

      if(this.state.reg_occured && !this.state.loading )
      {
          return(
            <div className="loading-progress text-center">
                <div className="error-message">
                    <p>{_this.state.evaluationFeedback}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress text-center">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderForm()
  {
    const _this = this;

    if(this.state.selectedLUnit != null && this.state.selectedLUnit != undefined )
    {
        return(
            <div id="evaluation-form" className ="row block-centered col-lg-12 col-md-12 full-width">
                <div className = "report-header" className ="row block-centered col-lg-12 col-md-12 full-width">
                  
                    <span className = "col-lg-12 text-center  header-title">{"LECTURER EVALUATION FORM"}</span>
                </div>

                <div className="col-lg-11 col-md-11 block-centered row full-width">
                    <span className="col-lg-12  sec-title">SECTION 1 : PROGRAM AND COURSE DETAILS</span>

                  
                    <span className="col-lg-12">
                            Programme :<span className="comic academic-info">{_this.props.student_details.class_details.programme}</span>
                    </span>

                    <span className="col-lg-12">
                            Year and Semester :<span className="comic academic-info">{" "+ _this.props.student_details.class_details.Semester + " , "+ _this.props.student_details.class_details.Year}</span>
                    </span>
                  
                   
                    <span className="col-lg-12">
                            Course Code and Title :<span className="comic academic-info">{" "+ _this.state.selectedLUnit.Code +" ("+ _this.state.selectedLUnit.Title +")"}</span>
                    </span>

                    <span className="col-lg-12">
                            Name of Lecturer :<span className="comic academic-info">{" "+ _this.state.selectedLUnit.Lecturer}</span>
                    </span>
                       
                </div>

                <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                    <span className="col-lg-12  sec-title">SECTION 02 :LECTURER ORGANIZATION AND PREPAREDNESS</span>
                    <span className="col-lg-12">The Lecturer</span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Provided clear course objectives</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.course_objectives === "Agree"}
                                    onChange={this.courseObjectives}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.course_objectives === "Not Sure"}
                                    onChange={this.courseObjectives}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.course_objectives === "Disagree"}
                                    onChange={this.courseObjectives}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                        </span>
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6 " style={{paddingLeft:0}}>Was punctual for lecture sessions</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="agree"
                                    checked={this.state.punctual === "agree"}
                                    onChange={this.punctuality}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="not sure"
                                    checked={this.state.punctual === "not sure"}
                                    onChange={this.punctuality}
                                />
                                 <span className ="radio-text">Not Sure</span>  
                            </span>

                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="disagree"
                                    checked={this.state.punctual === "disagree"}
                                    onChange={this.punctuality}
                                />
                                 <span className ="radio-text">Disagree</span>  
                            </span>
                        </span>
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Was prepared for each class session</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.prepared === "Agree"}
                                    onChange={this.preparedness}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.prepared === "Not Sure"}
                                    onChange={this.preparedness}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.prepared === "Disagree"}
                                    onChange={this.preparedness}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                       
                        </span>
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Used appropriate examples to explain content</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.appropriate_examples === "Agree"}
                                    onChange={this.appropriateExamples}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.appropriate_examples === "Not Sure"}
                                    onChange={this.appropriateExamples}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.appropriate_examples === "Disagree"}
                                    onChange={this.appropriateExamples}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                       
                        </span>
                    </span>    
                </div>

                <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                    <span className="col-lg-12  sec-title">SECTION 3 : TEACHING SKILLS AND STUDENT MANAGEMENT</span>
                    <span className="col-lg-12">The Lecturer</span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Interacted with students in class</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.interaction === "Agree"}
                                    onChange={this.interactivity}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.interaction === "Not Sure"}
                                    onChange={this.interactivity}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.interaction === "Disagree"}
                                    onChange={this.interactivity}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                     
                    </span>
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Stimulated interest in the course</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.stimulated_interest === "Agree"}
                                    onChange={this.stimulatedInterest}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.stimulated_interest === "Not Sure"}
                                    onChange={this.stimulatedInterest}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.stimulated_interest === "Disagree"}
                                    onChange={this.stimulatedInterest}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                        </span>
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Used diverse instructional methods in teaching (hand-outs, group discussions, practical examples, academic trips , student presentations)</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.diverse_instruction === "Agree"}
                                    onChange={this.diverseInstruction}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.diverse_instruction === "Not Sure"}
                                    onChange={this.diverseInstruction}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.diverse_instruction === "Disagree"}
                                    onChange={this.diverseInstruction}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                    </span>
                    </span>
                       
                </div>

                <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                    <span className="col-lg-12  sec-title">SECTION 4 : AVAILABILITY TO STUDENTS</span>
                    <span className="col-lg-12">The Lecturer</span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Was accessible to students for consultation outside of class</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.accessible_to_students === "Agree"}
                                    onChange={this.accessibleToStudents}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.accessible_to_students === "Not Sure"}
                                    onChange={this.accessibleToStudents}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.accessible_to_students === "Disagree"}
                                    onChange={this.accessibleToStudents}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                            </span>
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Was helpful to students with difficulties in the course</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.helpful_to_students === "Agree"}
                                    onChange={this.helpfulToStudents}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.helpful_to_students=== "Not Sure"}
                                    onChange={this.helpfulToStudents}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.helpful_to_students === "Disagree"}
                                    onChange={this.helpfulToStudents}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                            </span>
                           
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Offered individual attention to students where necessary</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                        <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.individual_attention === "Agree"}
                                    onChange={this.individualAttention}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.individual_attention === "Not Sure"}
                                    onChange={this.individualAttention}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.individual_attention === "Disagree"}
                                    onChange={this.individualAttention}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                     
                    </span>
                    </span>
                    
                        
                        
                </div>

                <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
               
                    <span className="col-lg-12  sec-title">SECTION 5 : TESTING AND EVALUATION</span>
                    <span className="col-lg-12">The Lecturer</span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Provided clear information on course assessment(CATs, Assignments)</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.info_on_assessment === "Agree"}
                                    onChange={this.infoOnAssessment}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.info_on_assessment === "Not Sure"}
                                    onChange={this.infoOnAssessment}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.info_on_assessment === "Disagree"}
                                    onChange={this.infoOnAssessment}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                            </span>
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Provided timely feedback on assignments</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.timely_feedback === "Agree"}
                                    onChange={this.timelyFeedback}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.timely_feedback === "Not Sure"}
                                    onChange={this.timelyFeedback}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.timely_feedback === "Disagree"}
                                    onChange={this.timelyFeedback}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                            </span>
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Gave sufficient number of assignments</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.sufficient_assignment === "Agree"}
                                    onChange={this.sufficientAssignment}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.sufficient_assignment === "Not Sure"}
                                    onChange={this.sufficientAssignment}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.sufficient_assignment === "Disagree"}
                                    onChange={this.sufficientAssignment}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                            </span>
                     
                    </span>      
                        
                </div>


                <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
     
                    <span className="col-lg-12  sec-title">SECTION 6 : OVERALL EXPERIENCE</span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>How do you rate your experience with the course</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                         <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Excellent"
                                    checked={this.state.overall_experience === "Excellent"}
                                    onChange={this.overallExperience}
                                />
                                <span className ="radio-text">Excellent</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Very Good"
                                    checked={this.state.overall_experience === "Very Good"}
                                    onChange={this.overallExperience}
                                />
                                <span className ="radio-text">Very Good</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Good"
                                    checked={this.state.overall_experience === "Good"}
                                    onChange={this.overallExperience}
                                />
                                <span className ="radio-text">Good</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Fair"
                                    checked={this.state.overall_experience === "Fair"}
                                    onChange={this.overallExperience}
                                />
                                <span className ="radio-text">Fair</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Poor"
                                    checked={this.state.overall_experience === "Poor"}
                                    onChange={this.overallExperience}
                                />
                                <span className ="radio-text">Poor</span>   
                            </span>
                            </span>
                     
                    </span>
                    <span className="col-lg-12 evaluation-entry">
                        <span className="col-lg-6" style={{paddingLeft:0}}>Do you wish to attend another course taught by the same lecturer</span>
                        <span className="col-lg-6" style={{paddingLeft:0}}>
                   
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Agree"
                                    checked={this.state.recommend === "Agree"}
                                    onChange={this.recommendation}
                                />
                                <span className ="radio-text">Agree</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Not Sure"
                                    checked={this.state.recommend === "Not Sure"}
                                    onChange={this.recommendation}
                                />
                                <span className ="radio-text">Not Sure</span>   
                            </span>
                            <span className="col-lg-4">
                                <input
                                    type="checkbox"
                                    value="Disagree"
                                    checked={this.state.recommend === "Disagree"}
                                    onChange={this.recommendation}
                                />
                                <span className ="radio-text">Disagree</span>   
                            </span>
                            </span>
                     
                    </span>      
                </div>

                <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                <button style={{float:"right"}} type="submit" onClick={_this.invalidateSelection.bind(_this)} onTap={_this.invalidateSelection.bind(_this)} className="btn btn-green">SUBMIT<div className="ripple-container"></div></button>  
                </div>

                


                
            </div>
        );
     
    }
    else
    {
        return null;
    }
  }

  renderSubmitButton()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderSelectBox()
  {
    const _this = this;
    let allLUnitsOptions;
       
    

    if(_this.state.allLUnits.length > 0)
    {
        allLUnitsOptions = _this.state.allLUnits.map(unit =>
            {
            return (
                <option value = {unit.Code} >{unit.Lecturer} - { unit.Code}:{unit.Title}</option>
                    );
            });
    }
    else
    {
        allLUnitsOptions=null;
    }


      if(_this.state.allLUnits.length > 0)
      {
          return(
            <div className="col-lg-8 block-centered text-center">

                <select type="select" value = "0" className="select-box" onChange = {this.updateSelectedLUnit.bind(_this)}>
                  <option value = "0" >Select Lecture and Unit</option>
                  {allLUnitsOptions}
                </select>
            </div>);
      }
      else{
          return null;
      }
  }

  renderMessage()
  {
    const _this = this;

    if(_this.state.allLUnits.length > 0)
    {
      return (<p className = "text-center full-width" style = {{paddingTop:"10px", paddingBottom:"10px"}}> Select  Lecture/Unit to load Evaluation Form </p>);
    }

    else {
      return (<p className = "text-center full-width" style = {{paddingTop:"10px", paddingBottom:"10px",  color:"red"}} >{this.state.units_message}</p>);
    }

  }

  renderContent()
  {
    const _this = this;
    if(_this.props.student_details.class_details.Semester && _this.props.student_details.class_details.Year)
        {
            return(
                <div className="tab-pane active" id="profile">
                            <h4 className ="text-center">LECTURE EVALUATION ({_this.props.student_details.class_details.Year} ,  {_this.props.student_details.class_details.Semester} )</h4>
                                {this.renderEvaluationFeedback()}
                                {this.renderMessage()}

                    <div className="row full-width col-lg-12 block-centered">
                        {_this.renderSelectBox()}
                    </div>
                    {_this.renderForm()}
            </div>

            );
        }
    else
    {
        return (
            <div className="tab-pane active" id="profile">
                <h4 className ="text-center">LECTURE EVALUATION</h4>
             <p className = "text-center full-width" style ={{paddingTop:"15px", paddingBottom:"15px", color:"red"}}> Current Semester and Year is not yet set for your class, hence  Lecturer evaluation cannot be done. Please contact your department.</p>
                                          
            </div>

        );
    }
  }

  componentWillMount()
  {
    //this.fetchUnits();
  }






  render() {

    const _this=this;
    let main_content;




    if(this.state.loading)
    {
        return(
            <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content">
                                  {_this.renderContent()}
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default LectureEvaluation;
